import { createElement } from 'react'

// Node Modules
import { domToReact, DomElement } from 'html-react-parser'

// Components
import Glossary from 'components/xis/Glossary'

// Util
import { generateID } from 'util/random'

export default (node:any, params:any, options:any) => {
  const children = node.children as DomElement[]

  const termEl = children.find(el => el.attribs?.['data-gloss-term'] !== undefined)
  const contentEl = children.filter(el => el.attribs?.['data-gloss-definition'] !== undefined)
  const labelEl = termEl?.children

  const term = termEl && domToReact([termEl], options)

  const contentReplace = (n:DomElement) => {
    // Links in a Glossary need to open in a new window
    if (n.name === 'a') {
      n.attribs = n.attribs || {}
      n.attribs['target'] = '_blank' 
    }

    return options.replace(n)
  }

  const contentOptions = {...options, replace: contentReplace }
  
  const content = contentEl && domToReact(contentEl, contentOptions)
  const label = labelEl && labelEl[0].data

  // Generate a random ID needed for a11y of Glossary, copied from AngularJS Help Center
  const id = generateID()

  return createElement(
    Glossary, 
    {
      id,
      term,
      content,
      label
    }, 
    null
  )
}